import React from "react";
import { useIntl } from "react-intl";

/*
  The tray of active filter chips. Presentational: the page decides what the chips say (display names, never raw
  ids) and what the callbacks do. It keeps its height whether or not filters are applied, so applying the first one
  does not push every panel down the page.

  chips: [{ dimension, dimensionLabel, value, label }]
*/
export const FilterTray = ({ chips, total, shown, onRemove, onClear, notices = [] }) => {
  const intl = useIntl();
  const active = chips.length > 0;
  const fmt = (n) => intl.formatNumber(n);

  return (
    <div className="ff-tray" data-active={String(active)} role="region" aria-label={intl.formatMessage({ id: "ff_dashboard.tray.label", defaultMessage: "FILTERS" })}>
      <span className="ff-tray-label" aria-hidden="true">
        {intl.formatMessage({ id: "ff_dashboard.tray.label", defaultMessage: "FILTERS" })}
      </span>

      {!active && (
        <span className="ff-tray-empty">
          {intl.formatMessage({ id: "ff_dashboard.tray.empty", defaultMessage: "None applied — select any bar, segment or row to filter the whole page" })}
        </span>
      )}

      {active && (
        <>
          <ul className="ff-chips">
            {chips.map((chip) => (
              <li className="ff-chip" key={`${chip.dimension}:${chip.value}`}>
                <span className="ff-dim">{chip.dimensionLabel}</span>
                {chip.label}
                <button
                  type="button"
                  aria-label={intl.formatMessage(
                    { id: "ff_dashboard.tray.remove", defaultMessage: "Remove filter {dimension} {value}" },
                    { dimension: chip.dimensionLabel, value: chip.label }
                  )}
                  onClick={() => onRemove(chip.dimension, chip.value)}
                >
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" aria-hidden="true">
                    <path d="M6 6l12 12M18 6L6 18" />
                  </svg>
                </button>
              </li>
            ))}
          </ul>
          <button type="button" className="ff-btn-clear" onClick={onClear}>
            {intl.formatMessage({ id: "ff_dashboard.tray.clear_all", defaultMessage: "Clear all" })}
          </button>
          <span className="ff-tray-count" role="status">
            {intl.formatMessage(
              { id: "ff_dashboard.tray.count", defaultMessage: "Showing {shown} of {total} leads" },
              { shown: fmt(shown), total: fmt(total) }
            )}
          </span>
        </>
      )}

      {notices.map((notice) => (
        <span className="ff-tray-notice" role="status" key={notice}>{notice}</span>
      ))}
    </div>
  );
};
